import CustomYear from "@/models/sis/CustomYear";

export const YearsModule = {
    namespaced: true,
    
    state: {
        years: [],
        isSetYears: false,
        error: null,
    },
    getters: {
        getYears: (state) => state.years,
        getYearsId: () => {
            return CustomYear.query().where('start', (val) => new Date(val) <= new Date()).where('end', (val) => new Date(val) >= new Date()).exists() ?
            CustomYear.query().where('start', (val) => new Date(val) <= new Date()).where('end', (val) => new Date(val) >= new Date()).first().id : null;
        },
        getIsSetYears: (state) => state.isSetYears,
        getError: (state) => state.error,
    },
    mutations: {
        set_years(state, years){
            state.years = years;
        },
        set_isSet(state, isSetYears){
            state.isSetYears = isSetYears;
        },
        set_error(state, error){
            state.error = error
        },
    },
    actions: {
        fetchYears({commit}){
            CustomYear.FetchAll({page: 1, limit: 999})
            .then(() => {
                const years = CustomYear.all();
                commit('set_years', years);
                commit('set_isSet', true);
            })
            .catch((err) => {
                commit('set_error', err);
            }) 
        }
    }
}